import React, { Component } from 'react'
import { connect } from 'react-redux'
import numeral from 'common/lib/numeral'
import { withStyles } from '@material-ui/core/styles';
import {styles} from 'common/lib/styles';

class PartRow extends Component {

  render () {
    const { part, estimates: { by_id, by_year, totals }, years, linkHandler, customer_id, projects, classes } = this.props;
    const { id, title, maintenance_interval, plan_id, bips_id } = part
    let total = (totals.by_id[id])
    if (isNaN(total)) {
        total = 0
    }
    const partProjects = projects.filter(p => (p.part_id == part.id));
    const estimateCells = years.map(year => {
        const extraordinary = part.establishment_year == year && part.establishment_cost ? numeral(part.establishment_cost/1000).format('0,0.0') : null
        let amount = 0;
        projects.filter(p => (p.year == year) && (p.part_id == part.id)).forEach(f => {
            amount += f.amount / 1000;
        });
        if (by_year[year] && by_year[year][id] && by_id[by_year[year][id]].estimate) {
            const currentYear = by_year[year]
            const currentEstimate = currentYear[id]
            return <td key={ year }>{ numeral(by_id[currentEstimate].estimate).format('0,0.0') } <div><span className="text-warning">{ extraordinary }</span></div></td>
        } else {
            total += amount;
        }
        return <td key={ year }>{amount ? numeral(amount).format('0,0.0') : null}<div><span className="text-warning">{ extraordinary }</span></div></td>
    })

    return <><tr>
            <td key="Title">
                <div onClick={linkHandler}>{ title }</div>
            </td>
            { estimateCells }
            <td key="Samlet">{ numeral(total).format('0,0.0') }</td>
        </tr>
        {partProjects.map(p => {
            let total = 0;
            return <tr className={classes.greyTextThin}>
            <td key="Title">
                <div onClick={linkHandler}>{ p.title }</div>
            </td>
            {years.map(year => {
                if (p.year == year) {
                    total = p.amount / 1000
                    return <td>{total}</td>
                }
                return <td></td>
            })}
            <td key="Samlet">{ numeral(total).format('0,0.0') }</td>
        </tr>
        })}</>
  }
}


const mapStateToProps = state => {
  return {
    plan: state.data.customer.plan,
    projects: state.data.customer.projects,
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PartRow))
